import { useMutation } from '@apollo/client';
import { graphql } from 'gql.tada';

const CreateGradebookMutation = graphql.persisted(
  'CreateGradebook',
  graphql(`
    mutation CreateGradebook($input: CreateGradebookInput!) {
      createGradebook(input: $input) {
        gradebook { id }
        userErrors { message path }
      }
    }
  `)
);

const DeleteGradebookMutation = graphql.persisted(
  'DeleteGradebook',
  graphql(`
    mutation DeleteGradebook($input: DeleteGradebookInput!) {
      deleteGradebook(input: $input) {
        success
        userErrors { message path }
      }
    }
  `)
);

const FinalizeGradebookMutation = graphql.persisted(
  'FinalizeGradebook',
  graphql(`
    mutation FinalizeGradebook($input: FinalizeGradebookInput!) {
      finalizeGradebook(input: $input) {
        gradebook { id finalized }
        finalization { id revision resultCount finalizedAt }
        userErrors { message path }
      }
    }
  `)
);

const FinalizeClassGradebooksMutation = graphql.persisted(
  'FinalizeClassGradebooks',
  graphql(`
    mutation FinalizeClassGradebooks($input: FinalizeClassGradebooksInput!) {
      finalizeClassGradebooks(input: $input) {
        classOffering { id }
        finalizations { id revision resultCount finalizedAt }
        pointsGradebookCount
        finalizedCount
        alreadyFinalizedCount
        userErrors { message path }
      }
    }
  `)
);

const ReopenGradebookMutation = graphql.persisted(
  'ReopenGradebook',
  graphql(`
    mutation ReopenGradebook($input: ReopenGradebookInput!) {
      reopenGradebook(input: $input) {
        gradebook { id finalized }
        previousFinalization { id revision }
        userErrors { message path }
      }
    }
  `)
);

export {
  CreateGradebookMutation,
  DeleteGradebookMutation,
  FinalizeGradebookMutation,
  FinalizeClassGradebooksMutation,
  ReopenGradebookMutation,
};

export function useCreateGradebook() {
  return useMutation(CreateGradebookMutation);
}

export function useDeleteGradebook() {
  return useMutation(DeleteGradebookMutation);
}

export function useFinalizeGradebook() {
  return useMutation(FinalizeGradebookMutation);
}

export function useFinalizeClassGradebooks() {
  return useMutation(FinalizeClassGradebooksMutation);
}

export function useReopenGradebook() {
  return useMutation(ReopenGradebookMutation);
}
